import { useQuery } from '@tanstack/react-query';
import { exchangeWeeklyReportToken, getWeeklyReportPeriod } from '@/services/api/requests/weekly-report';
import { useAuthContext } from '@/context/auth/useAuthContext';

export const weeklyReportQueryKey = (period?: string, token?: string, userId?: string) =>
  token ? ['weekly-report-link', token, userId ?? null] : ['weekly-report', period];

const useWeeklyReportPeriod = (period?: string, token?: string) => {
  const { user } = useAuthContext();
  return useQuery({
    queryKey: weeklyReportQueryKey(period, token, user?.user_id),
    queryFn: () => (token ? exchangeWeeklyReportToken(token) : getWeeklyReportPeriod(period)),
    retry: false,
  });
};

export default useWeeklyReportPeriod;
